"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.CosmosApp = void 0;
/** ******************************************************************************
 *  (c) 2018 - 2022 Zondax AG
 *
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 ******************************************************************************* */
var common_1 = require("./common");
var commandsV1_1 = require("./commandsV1");
var commandsV2_1 = require("./commandsV2");
var crypto = require('crypto');
var bech32 = require('bech32');
var Ripemd160 = require('ripemd160');
var CosmosApp = /** @class */ (function () {
    function CosmosApp(transport) {
        if (!transport) {
            throw new Error('Transport has not been defined');
        }
        this.transport = transport;
    }
    CosmosApp.serializeHRP = function (hrp) {
        if (hrp == null || hrp.length < 3 || hrp.length > 83) {
            throw new Error('Invalid HRP');
        }
        var buf = Buffer.alloc(1 + hrp.length);
        buf.writeUInt8(hrp.length, 0);
        buf.write(hrp, 1);
        return buf;
    };
    CosmosApp.getBech32FromPK = function (hrp, pk) {
        if (pk.length !== 33) {
            throw new Error('expected compressed public key [31 bytes]');
        }
        var hashSha256 = crypto.createHash('sha256').update(pk).digest();
        var hashRip = new Ripemd160().update(hashSha256).digest();
        return bech32.encode(hrp, bech32.toWords(hashRip));
    };
    CosmosApp.prototype.serializePath = function (path) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, (0, common_1.getVersion)(this.transport)];
                    case 1:
                        _a.versionResponse = _b.sent();
                        if (this.versionResponse.return_code !== common_1.ERROR_CODE.NoError) {
                            throw this.versionResponse;
                        }
                        switch (this.versionResponse.major) {
                            case 1:
                                return [2 /*return*/, (0, commandsV1_1.serializePathv1)(path)];
                            case 2:
                                return [2 /*return*/, (0, commandsV2_1.serializePathv2)(path)];
                            default:
                                return [2 /*return*/, Buffer.alloc(0)];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    CosmosApp.prototype.signGetChunks = function (path, buffer) {
        return __awaiter(this, void 0, void 0, function () {
            var serializedPath, chunks, i, end;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.serializePath(path)];
                    case 1:
                        serializedPath = _a.sent();
                        chunks = [];
                        chunks.push(serializedPath);
                        for (i = 0; i < buffer.length; i += common_1.CHUNK_SIZE) {
                            end = i + common_1.CHUNK_SIZE;
                            if (i > buffer.length) {
                                end = buffer.length;
                            }
                            chunks.push(buffer.slice(i, end));
                        }
                        return [2 /*return*/, chunks];
                }
            });
        });
    };
    CosmosApp.prototype.getVersion = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        _a = this;
                        return [4 /*yield*/, (0, common_1.getVersion)(this.transport)];
                    case 1:
                        _a.versionResponse = _b.sent();
                        return [2 /*return*/, this.versionResponse];
                    case 2:
                        e_1 = _b.sent();
                        return [2 /*return*/, (0, common_1.processErrorResponse)(e_1)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CosmosApp.prototype.appInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.transport.send(0xb0, 0x01, 0, 0).then(function (response) {
                        var errorCodeData = response.slice(-2);
                        var returnCode = errorCodeData[0] * 256 + errorCodeData[1];
                        var appName = '';
                        var appVersion = '';
                        var flagLen = 0;
                        var flagsValue = 0;
                        if (response[0] !== 1) {
                            // Ledger responds with format ID 1. There is no spec for any format != 1
                            return {
                                return_code: 0x9001,
                                error_message: 'response format ID not recognized'
                            };
                        }
                        else {
                            var appNameLen = response[1];
                            appName = response.slice(2, 2 + appNameLen).toString('ascii');
                            var idx = 2 + appNameLen;
                            var appVersionLen = response[idx];
                            idx += 1;
                            appVersion = response.slice(idx, idx + appVersionLen).toString('ascii');
                            idx += appVersionLen;
                            var appFlagsLen = response[idx];
                            idx += 1;
                            flagLen = appFlagsLen;
                            flagsValue = response[idx];
                        }
                        return {
                            return_code: returnCode,
                            error_message: (0, common_1.errorCodeToString)(returnCode),
                            // //
                            appName: appName,
                            appVersion: appVersion,
                            flagLen: flagLen,
                            flagsValue: flagsValue,
                            // eslint-disable-next-line no-bitwise
                            flag_recovery: (flagsValue & 1) !== 0,
                            // eslint-disable-next-line no-bitwise
                            flag_signed_mcu_code: (flagsValue & 2) !== 0,
                            // eslint-disable-next-line no-bitwise
                            flag_onboarded: (flagsValue & 4) !== 0,
                            // eslint-disable-next-line no-bitwise
                            flag_pin_validated: (flagsValue & 128) !== 0
                        };
                    }, common_1.processErrorResponse)];
            });
        });
    };
    CosmosApp.prototype.deviceInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.transport.send(0xe0, 0x01, 0, 0, Buffer.from([]), [common_1.ERROR_CODE.NoError, 0x6e00]).then(function (response) {
                        var errorCodeData = response.slice(-2);
                        var returnCode = errorCodeData[0] * 256 + errorCodeData[1];
                        if (returnCode === 0x6e00) {
                            return {
                                return_code: returnCode,
                                error_message: 'This command is only available in the Dashboard'
                            };
                        }
                        var targetId = response.slice(0, 4).toString('hex');
                        var pos = 4;
                        var secureElementVersionLen = response[pos];
                        pos += 1;
                        var seVersion = response.slice(pos, pos + secureElementVersionLen).toString();
                        pos += secureElementVersionLen;
                        var flagsLen = response[pos];
                        pos += 1;
                        var flag = response.slice(pos, pos + flagsLen).toString('hex');
                        pos += flagsLen;
                        var mcuVersionLen = response[pos];
                        pos += 1;
                        // Patch issue in mcu version
                        var tmp = response.slice(pos, pos + mcuVersionLen);
                        if (tmp[mcuVersionLen - 1] === 0) {
                            tmp = response.slice(pos, pos + mcuVersionLen - 1);
                        }
                        var mcuVersion = tmp.toString();
                        return {
                            return_code: returnCode,
                            error_message: (0, common_1.errorCodeToString)(returnCode),
                            // //
                            targetId: targetId,
                            seVersion: seVersion,
                            flag: flag,
                            mcuVersion: mcuVersion
                        };
                    }, common_1.processErrorResponse)];
            });
        });
    };
    CosmosApp.prototype.publicKey = function (path) {
        return __awaiter(this, void 0, void 0, function () {
            var serializedPath, data, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.serializePath(path)];
                    case 1:
                        serializedPath = _a.sent();
                        switch (this.versionResponse.major) {
                            case 1:
                                return [2 /*return*/, (0, commandsV1_1.publicKeyv1)(this, serializedPath)];
                            case 2: {
                                data = Buffer.concat([CosmosApp.serializeHRP('cosmos'), serializedPath]);
                                return [2 /*return*/, (0, commandsV2_1.publicKeyv2)(this, data)];
                            }
                            default:
                                return [2 /*return*/, {
                                        return_code: 0x6400,
                                        error_message: 'App Version is not supported'
                                    }];
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        e_2 = _a.sent();
                        return [2 /*return*/, (0, common_1.processErrorResponse)(e_2)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CosmosApp.prototype.getAddressAndPubKey = function (path, hrp, showInDevice) {
        if (showInDevice === void 0) { showInDevice = false; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.serializePath(path)
                        .then(function (serializedPath) {
                        var data = Buffer.concat([CosmosApp.serializeHRP(hrp), serializedPath]);
                        return _this.transport
                            .send(common_1.CLA, common_1.INS.GET_ADDR_SECP256K1, showInDevice ? common_1.P1_VALUES.SHOW_ADDRESS_IN_DEVICE : common_1.P1_VALUES.ONLY_RETRIEVE, 0, data, [common_1.ERROR_CODE.NoError])
                            .then(function (response) {
                            var errorCodeData = response.slice(-2);
                            var returnCode = errorCodeData[0] * 256 + errorCodeData[1];
                            var compressedPk = Buffer.from(response.slice(0, 33));
                            var bech32Address = Buffer.from(response.slice(33, -2)).toString();
                            return {
                                bech32_address: bech32Address,
                                compressed_pk: compressedPk,
                                return_code: returnCode,
                                error_message: (0, common_1.errorCodeToString)(returnCode)
                            };
                        }, common_1.processErrorResponse);
                    })["catch"](function (err) { return (0, common_1.processErrorResponse)(err); })];
            });
        });
    };
    CosmosApp.prototype.showAddressAndPubKey = function (path, hrp) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.getAddressAndPubKey(path, hrp, true)];
            });
        });
    };
    CosmosApp.prototype.signSendChunk = function (chunkIdx, chunkNum, chunk, txType) {
        if (txType === void 0) { txType = common_1.P2_VALUES.JSON; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (this.versionResponse.major) {
                    case 1:
                        return [2 /*return*/, (0, commandsV1_1.signSendChunkv1)(this, chunkIdx, chunkNum, chunk, txType)];
                    case 2:
                        return [2 /*return*/, (0, commandsV2_1.signSendChunkv2)(this, chunkIdx, chunkNum, chunk, txType)];
                    default:
                        return [2 /*return*/, {
                                return_code: 0x6400,
                                error_message: 'App Version is not supported'
                            }];
                }
                return [2 /*return*/];
            });
        });
    };
    CosmosApp.prototype.sign = function (path, buffer, txType) {
        if (txType === void 0) { txType = common_1.P2_VALUES.JSON; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.signGetChunks(path, buffer).then(function (chunks) {
                        return _this.signSendChunk(1, chunks.length, chunks[0], txType).then(function (response) { return __awaiter(_this, void 0, void 0, function () {
                            var result, i;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        result = {
                                            return_code: response.return_code,
                                            error_message: response.error_message,
                                            signature: null
                                        };
                                        i = 1;
                                        _a.label = 1;
                                    case 1:
                                        if (!(i < chunks.length)) return [3 /*break*/, 4];
                                        return [4 /*yield*/, this.signSendChunk(1 + i, chunks.length, chunks[i], txType)];
                                    case 2:
                                        // eslint-disable-next-line no-await-in-loop
                                        result = _a.sent();
                                        if (result.return_code !== common_1.ERROR_CODE.NoError) {
                                            return [3 /*break*/, 4];
                                        }
                                        _a.label = 3;
                                    case 3:
                                        i += 1;
                                        return [3 /*break*/, 1];
                                    case 4: return [2 /*return*/, {
                                            return_code: result.return_code,
                                            error_message: result.error_message,
                                            // ///
                                            signature: result.signature
                                        }];
                                }
                            });
                        }); }, common_1.processErrorResponse);
                    }, common_1.processErrorResponse)];
            });
        });
    };
    return CosmosApp;
}());
exports.CosmosApp = CosmosApp;
//# sourceMappingURL=cosmosApp.js.map